import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

const TimesheetBulkRejectModal = ({
    showValidationModal,
    setShowValidationModal,
    selectedEntries,
    validationComment,
    setValidationComment,
    confirmBulkReject
}) => {
    if (!showValidationModal) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
        }}>
            <div style={{
                background: 'var(--color-surface)',
                padding: '2rem',
                borderRadius: 'var(--border-radius-lg)',
                maxWidth: '500px',
                width: '90%',
                boxShadow: 'var(--shadow-xl)'
            }}>
                <h3 style={{ marginTop: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <FontAwesomeIcon icon={faTimesCircle} style={{ color: '#ef4444' }} />
                    Rejeter les entrées sélectionnées
                </h3>
                <p style={{ color: 'var(--color-text-light)', marginBottom: '1.5rem' }}>
                    Vous êtes sur le point de rejeter {selectedEntries.length} entrée(s).
                    Veuillez indiquer la raison du rejet :
                </p>
                <textarea
                    value={validationComment}
                    onChange={(e) => setValidationComment(e.target.value)}
                    placeholder="Raison du rejet (optionnel)..."
                    rows="4"
                    style={{
                        width: '100%',
                        padding: '12px',
                        border: '1px solid var(--color-light-gray)',
                        borderRadius: 'var(--border-radius-md)',
                        fontSize: '0.95rem',
                        fontFamily: 'inherit',
                        resize: 'vertical',
                        backgroundColor: 'var(--color-background)',
                        color: 'var(--color-text)',
                        marginBottom: '1.5rem'
                    }}
                />
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                    <button
                        onClick={() => {
                            setShowValidationModal(false);
                            setValidationComment('');
                        }}
                        style={{
                            padding: '10px 20px',
                            border: '1px solid var(--color-light-gray)',
                            borderRadius: '6px',
                            background: 'transparent',
                            color: 'var(--color-text)',
                            fontWeight: '600',
                            cursor: 'pointer'
                        }}
                    >
                        Annuler
                    </button>
                    <button
                        onClick={confirmBulkReject}
                        style={{
                            padding: '10px 20px',
                            border: 'none',
                            borderRadius: '6px',
                            background: '#ef4444',
                            color: 'white',
                            fontWeight: '600',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px'
                        }}
                    >
                        <FontAwesomeIcon icon={faTimesCircle} />
                        Confirmer le rejet
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TimesheetBulkRejectModal;
